"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var router_1 = require("@angular/router");
var DriverGuard = /** @class */ (function () {
    function DriverGuard(router) {
        this.router = router;
    }
    DriverGuard.prototype.canActivate = function (route, state) {
        var currentUser = JSON.parse(localStorage.getItem('currentUser'));
        if (currentUser && currentUser.driver) {
            // logged in so return true
            return true;
        }
        // not logged in so redirect to login page with the return url
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        return false;
    };
    return DriverGuard;
}());
exports.DriverGuard = DriverGuard;
